<div class="container-fluid g-0 m-0">
    <div class="d-flex g-0 m-0">
        <div class="sidemenu-nav background-color">
            <h6 class="sidemenu-title">{{ "GENERAL" | translate }}</h6>
            @if(authService.isAuthorized([PermissionEnum.Systemmonitoring_acquisition_view])){
                <div class="sidemenu-item-font item"
                    (click)="navigate('system-monitoring/acquisition')"
                    [ngClass]="{ selected: isActive('system-monitoring/acquisition') }">
                    <span>{{ "MONITORING_ACQUISITION" | translate }}</span>
                </div>
            }
            @if(authService.isAuthorized([PermissionEnum.Systemmonitoring_deviceconnectiontime_view])){
                <div class="sidemenu-item-font item"
                    (click)="navigate('system-monitoring/device-connection-time')"
                    [ngClass]="{ selected: isActive('system-monitoring/device-connection-time') }">
                    <span>{{ "MONITORING_DEVICECONNECTION" | translate }}</span>
                </div>
            }
            @if(authService.isAuthorized([PermissionEnum.Scheduler_view])){
                <div class="sidemenu-item-font item"
                    (click)="navigate('system-monitoring/job-status-history')"
                    [ngClass]="{ selected: isActive('system-monitoring/job-status-history') }">
                    <span>{{ "JOBSTATUSHISTORY_TITLE" | translate }}</span>
                </div>
            }
        </div>
        <div class="sidemenu-content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
